import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

/** Blocks order creation while some selected panel types are not approved yet. */
export function UnapprovedTypesDialog({ open, onOpenChange, types }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="unapproved-types-dialog"
        className="max-w-md border-slate-200 bg-white text-slate-800"
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg tracking-tight">
            <AlertTriangle size={18} className="text-amber-500" />
            Order cannot be created
          </DialogTitle>
        </DialogHeader>

        <p className="text-[12.5px] text-slate-600">
          The material list of the following panel types has not been approved yet. Ask Design to
          approve them in Panel Properties, then create the order again.
        </p>

        <div
          data-testid="unapproved-types-list"
          className="okn-scroll max-h-56 space-y-1 overflow-y-auto pr-1"
        >
          {(types || []).map((name) => (
            <div
              key={name}
              data-testid={`unapproved-type-${name}`}
              className="mono rounded-lg border border-amber-200 bg-amber-50 px-3 py-1.5 text-[11.5px] text-amber-900"
            >
              {name}
            </div>
          ))}
        </div>

        <Button
          data-testid="unapproved-dialog-close"
          onClick={() => onOpenChange(false)}
          className="mt-1 h-9 rounded-full bg-slate-900 text-[11px] uppercase tracking-wider text-white hover:bg-slate-800"
        >
          Understood
        </Button>
      </DialogContent>
    </Dialog>
  );
}
